import axios from "@/helpers/axios";

export default class {
    static TYPE = Object.freeze({
        ELEVES: "eleves",
        TUTEURS: "tuteurs",
        NIVEAUX: "niveaux",
        NIVEAU_CLASSES: "niveau-classes",
        NIVEAU_GROUPES: "niveau-groupes",
        REGLEMENTS: "reglements",
        RUBRIQUES: "rubriques",
        SERVICES: "services",
        LISTE_MOIS: "liste-mois",
        CAISSE_OPERATIONS: "caisse-operations",
        BANQUE_OPERATIONS: "banque-operations",
        CHEQUE_SUIVIS: "cheque-suivis",
        EMPLOYEES: "employees",
        TRANSPORTS: "transports",
        FONCTIONEMPLOYEE: "fonctions",
        STATIONS: "stations",
        VISITES: "visites",
        INSCRIPTIONS: "inscriptions"
    });

    static Service;

    static GetAll(params = {}) {
        let payload = { params };
        if (params.export) {
            payload.responseType = "blob";
        }

        return new Promise(resolve => {
            axios.get(this.Service, payload).then(resp => {
                resolve(resp);
            });
        });
    }

    static GetOptions() {
        return new Promise(resolve => {
            axios.get(`${this.Service}/options`).then(resp => {
                resolve(resp);
            });
        });
    }

    static GetHelpers() {
        return new Promise(resolve => {
            axios.get(`${this.Service}/helpers`).then(resp => {
                resolve(resp);
            });
        });
    }

    static GetFiltersData() {
        return new Promise(resolve => {
            axios.get(`${this.Service}/filters`).then(resp => {
                resolve(resp);
            });
        });
    }

    static Get(id) {
        return new Promise(resolve => {
            axios.get(`${this.Service}/${id}`).then(resp => {
                resolve(resp);
            });
        });
    }

    static Update(data) {
        const values = { ...data };
        for (const key in values) {
            values[key] = values[key]?.id || values[key];
        }

        return new Promise(resolve => {
            axios.post(this.Service, values).then(resp => {
                resolve(resp);
            });
        });
    }

    static Delete(id) {
        return new Promise(resolve => {
            axios.delete(this.Service, { data: { id } }).then(resp => {
                resolve(resp);
            });
        });
    }

    static Create(data) {
        return new Promise(resolve => {
            axios.post(this.Service, data).then(resp => {
                resolve(resp);
            });
        });
    }

    static _getIdsFromArray(value) {
        if (Array.isArray(value)) {
            return value.map(item => item?.id || item);
        }
        return value;
    }

    static _getNestedItems(obj, newKey) {
        if (obj && typeof obj == "object" && !Array.isArray(obj)) {
            let arrays = Object.entries(obj).map(item => this._getNestedItems(item[1], newKey + "." + item[0]));
            arrays = [].concat(...arrays);
            return arrays;
        } else {
            return { [newKey]: obj };
        }
    }
}
